module.exports = "/_next/static/resources/array-082fe733c4beabc3ace5db58aff07f37.jpg";